import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import i18n from 'i18next';
import { SUB_ADMIN_TYPES } from "assets/constants";

const ProtectedRoute = ({ isAdmin = false, isSubAdmin = false}) => {
    const { adminUser } = useSelector((store) => store.admin);

   if (isAdmin) {
        return adminUser?.type === "owner" ? <Outlet /> : redirectToPath(`/${i18n.language}/admin-login`);
    } else if (isSubAdmin) {
        return SUB_ADMIN_TYPES.includes(adminUser?.type) ? <Outlet /> : redirectToPath(`/${i18n.language}/admin-login`);
    } 
    function redirectToPath(path) {
        window.location.replace(path)
    }
}

export default ProtectedRoute;
